/**
 * Created by lileilei on 2018/1/04.
 *description iwo的链接稿
 */
'use strict';
angular.module('iWoLinkDocModule', []).controller('iWoLinkDocController', [
    '$scope',
    'beforeonload',
    '$validation',
    '$compile',
    '$element',
    '$sce',
    '$q',
    '$state',
    '$stateParams',
    '$window',
    'trsHttpService',
    'initiWoDataService',
    '$filter',
    '$timeout',
    'storageListenerService',
    'jsonArrayToStringService',
    'modalDialog',
    'initeditctrBtnsService',
    'editingCenterService',
    'iWoinitBtnService',
    'filterEditctrBtnsService',
    'iWoBtnService',
    'sensitiveWordCheckService',
    'iWoService',
    'editIsLock',
    function (
        $scope,
        beforeonload,
        $validation,
        $compile,
        $element,
        $sce,
        $q,
        $state,
        $stateParams,
        $window,
        trsHttpService,
        initiWoDataService,
        $filter,
        $timeout,
        storageListenerService,
        jsonArrayToStringService,
        modalDialog,
        initeditctrBtnsService,
        editingCenterService,
        iWoinitBtnService,
        filterEditctrBtnsService,
        iWoBtnService,
        sensitiveWordCheckService,
        iWoService,
        editIsLock
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description]
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
            };
            $scope.params = {
                serviceid: 'mlf_myrelease',
                methodname: 'getLinkDoc',
                ChnlDocId: $stateParams.iwochnldocid,
            };
            $scope.status = {
                newsFormError: [],
                nopayment: false,
                switch: 'manuscriptInfo', // 默认选中稿件信息
                isEditDraft: !!$stateParams.iwometadataid,
                metadataid: $stateParams.iwometadataid,
                hasVersionTime: false,
                isCheckSensitiveWords: false,
                sensitiveWordTit: '敏感词校验',
                linkDocSaveMethod: ['savePersonalLinkDoc', 'saveReceivedLinkDoc'],
                isFusionEditor: $state.current.name == 'fusionlinkdoc', // 是否来自融合编辑器
            };
            $scope.returnParams = {}; // 链接协议同意返回的内容
            $scope.data = {
                copyVersion: [],
                srcUrl: '', // 由稿件链接生成的稿件页面
                path: {
                    '-1': 'editingCenterIwoPersonalVersionTime',
                    '1': 'editingCenterAppPersonalVersionTime',
                    '2': 'editingCenterWebsitePersonalVersionTime',
                    '3': 'editingCenterPaperPersonalVersionTime',
                    '4': 'editingCenterWeixinPersonalVersionTime',
                },
                comment: {
                    comment: [],
                    voiceObj: {},
                    hasMore: false,
                    currPage: 1,
                },
            };
            $scope.handleBtnClick = function (funname) {
                eval('$scope.' + funname + '()');
            };
            // 初始化标签
            emitCloseWindow();
            $scope.editFlag = {
                media: 'iwo',
                docType: 'linkdoc',
            };
        }

        /**
         * [theFormError description] 获取表单变化
         * @return {[type]} [description]
         */
        $scope.theFormError = function () {
            // 当表单发生变化时会进入方法
            var errorArray = [];
            for (var error in $scope.linkForm.$error) {
                errorArray.push(error);
            }
            $scope.status.newsFormError = $scope.status.newsFormError == undefined ? [] : $scope.status.newsFormError;
            if ($scope.status.newsFormError.length != errorArray.length) {
                // 长度不相等说明表单errorname发生变化
                $scope.status.newsFormError = errorArray;
            }
            return $scope.status.newsFormError; // 返回
        };
      
        /**
         * [emitCloseWindow description]标签页关闭页面时，发送稿件解锁信息给其他页面，协助解锁该稿件
         * @return {[type]} [description]
         */
        function emitCloseWindow() {
            editingCenterService.allAppCloseWindow($scope, { typeName: 'iwo', saveLocal: false });

        }

        /**
         * [initData description] 初始化数据
         * @return  {[type]}  [return description]
         */
        function initData() {
            storageListenerService.removeListener('iwo');
            if (!$scope.status.isFusionEditor) {
                ($stateParams.iwometadataid ? initEditData() : initNewData()).then(function () {
                    beforeonload.beforeonloadAlert($scope);
                });
            }
            initArrayBtn();
            // loadDirective();
        }

        /**
         * [initEditData description] 编辑数据
         * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
         * @return {[type]} [description]
         */
        function initEditData(dealWithListFun) {
            var defer = $q.defer();
            $scope.params = {
                serviceid: 'mlf_myrelease',
                methodname: 'getLinkDoc',
                MetaDataId: $stateParams.iwometadataid,
            };
            iWoService.initData().then(function (data) {
                $scope.DOCGENRES = data.DocGenre;
                // 初始化页面参数
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function (data) {
                    $scope.list = data;
                    document.title = data.TITLE;
                    $scope.list.MEDIATYPES = data.MEDIATYPES_DB;
                    // 初始化原创类型
                    // 融合编辑器下处理list
                    if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                        dealWithListFun();
                    }
                    // 获取流程版本与操作日志
                    getVersion().then(function () {
                        defer.resolve();
                    });
                });
                // 获取评审意见
                getComment($stateParams.iwometadataid, $scope.data.comment.currPage);
            });
            return defer.promise;
        }

        /**
         * [initNewData description] 新建数据
         * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
         * @return {[type]} [description]
         */
        function initNewData(dealWithListFun) {
            $scope.list = initiWoDataService.initLink();
            initDocgenre().then(() => {
                // 融合编辑器下处理list
                if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                    dealWithListFun();
                }
            });
        }

        /**
         * [loadDirective description] 动态加载
         * @return  {[type]}  [return description]
         */
        function loadDirective() {
            editingCenterService.loadManuscriptType($scope, $element); // 加载稿件原创部分
            if (!$scope.status.isFusionEditor) {
                var draftList =
                    '<editor-dir list="list"  meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="linkForm"></editor-dir>' +
                    '<editor-auth-dir author="list.FGD_AUTHINFO" originalchildtype="list.ORIGINAL==1&&data.originType==3?1:0"></editor-auth-dir>';
                draftList = $compile(draftList)($scope);
                $element.find('editor').append(draftList);
            }
        }

        /**
         * [initDocgenre description]初始化稿件体裁
         * @return {[type]} [description]
         */
        function initDocgenre() {
            let defer = $q.defer();
            iWoService.initData().then(function (data) {
                $scope.DOCGENRES = data.DocGenre;
                $scope.list.DOCGENRE = angular.copy($scope.DOCGENRES[0]);
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [initArrayBtn description] 初始化权限
         * @return  {[type]}  [return description]
         */
        function initArrayBtn() {
            $scope.methodnameArray = ['iwo.personal', 'iwo.received'];
            $scope.dictionaryArray = [iWoBtnService.initIwoPersonBtn(), iWoBtnService.initIwoReceiveBtn()];
            $scope.iWoBtns = iWoinitBtnService.initBtnArrays()[$stateParams.iwoplatform];
            initeditctrBtnsService.initIwoData($scope.methodnameArray[$stateParams.iwoplatform]).then(function (data) {
                $scope.btnStatus = initeditctrBtnsService.initBtns(data, $scope.dictionaryArray[$stateParams.iwoplatform]);
                $scope.arrayBtn = filterEditctrBtnsService.filterBtn($scope.btnStatus, $scope.iWoBtns);
                addBtn();
            });
        }

        /**
         * [getComment description] 获取评审意见
         * @param   {[type]}  id        [id description]
         * @param   {[type]}  currPage  [currPage description]
         * @return  {[type]}            [return description]
         */
        function getComment(id, currPage) {
            editingCenterService.getComment(id, currPage).then(function (data) {
                if (
                    angular.isDefined($scope.data.comment.comment[$scope.data.comment.comment.length - 1]) &&
                    $filter('date')($scope.data.comment.comment[$scope.data.comment.comment.length - 1].day, 'yyyy-MM-dd').toString() ==
                    $filter('date')(data.comment[0].day, 'yyyy-MM-dd').toString()
                ) {
                    $scope.data.comment.comment[$scope.data.comment.comment.length - 1].times = $scope.data.comment.comment[
                        $scope.data.comment.comment.length - 1
                    ].times.concat(data.comment[0].times);
                    data.comment.shift();
                }
                $scope.data.comment['comment'] = $scope.data.comment['comment'].concat(data.comment);
                $scope.data.comment.hasMore = data.hasMore;
                for (var i in data.voiceObj) {
                    $scope.data.comment.voiceObj[i] = data.voiceObj[i];
                }
            });
        }

        /**
         * [save description]保存函数
         * @return {[type]} [description]
         */
        $scope.save = function () {
            var defer = $q.defer();
            save(true).then(
                function () {
                    if ($scope.$root.cureditpage === undefined || $scope.$root.cureditpage === 'iwolinkdoc') {
                        editIsLock.lockDraft($stateParams.iwometadataid);
                        getVersion($scope.list.METADATAID);
                    }
                    defer.resolve();
                },
                function (msg) {
                    defer.reject(msg);
                }
            );
            return defer.promise;
        };

        /**
         * [getVersion description] 获取流程版本与操作日志
         * @param   {[type]}  id  [id description]
         * @return  {[type]}      [return description]
         */
        function getVersion(id) {
            var defer = $q.defer();
            var metadataid = angular.isDefined(id) ? id : $stateParams.iwometadataid;
            editingCenterService.getEditVersionTime(metadataid, $scope.page, $scope.data.copyVersion).then(function (data) {
                $scope.data.version = data;
                $scope.page = data.page;
                $scope.data.copyVersion = data.copyArray;
                $scope.status.hasVersionTime = true;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [isShowVersion description] 没有操作日志或流程版本时不显示图标和'没有更多'
         * @param  {[type]}  key [description] 操作日志或流程版本的数据
         * @return {Boolean}     [description]
         */
        $scope.isShowVersion = function (key) {
            if (key === undefined) {
                return false;
            } else {
                for (var i in key) {
                    return true;
                }
                return false;
            }
        };

        /**
         * [getLoadMore description]操作日志加载更多
         * @return {[type]} [description]
         */
        $scope.getLoadMore = function () {
            $scope.page.CURRPAGE++;
            getVersion();
        };

        /**
         * [openPersonalVersionTime description] 打开流程版本详情页
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.openPersonalVersionTime = function (item) {
            var path = $scope.data.path[item.MEDIATYPE];
            var params = {
                objectversionid: item.OBJECTVERSIONID,
                chnldocid: $stateParams.iwochnldocid,
            };
            var url = $state.href(path, params);
            item.url = url;
        };

        /**
         * [close description]关闭页面
         * @return {[type]} [description]
         */
        $scope.close = function () {
            editingCenterService.closeWinow($scope.linkForm.$dirty, false).then(
                function () {
                    save().then(function () {
                        storageListenerService.addListenerToIwo('newsSaved');
                        $window.open('about:blank', '_self').close();
                    });
                },
                function () {
                    $window.open('about:blank', '_self').close();
                }
            );
        };

        /**
         * [dealAttributeBeforeSave description]在保存前处理数据
         * @return {[type]} [description]
         */
        function dealAttributeBeforeSave() {
            $scope.linkForm.$setPristine();
            $scope.list.serviceid = 'mlf_myrelease'; // 在编辑时后台为返回服务名
            $scope.list.METHODNAME = $state.params.fromType ? 'saveDeptNews' : $scope.status.linkDocSaveMethod[$stateParams.iwoplatform];
            $scope.list.PLATEFORM = $stateParams.iwoplatform;
            $scope.list.DOCRELTIME = $filter('date')(new Date(), 'yyyy-MM-dd HH:mm').toString();
            $scope.list.ORIGINALTYPE = $scope.data.originType;
            $scope.list.SPECIALDOC = $scope.data.specialDoc;
            $scope.list.CONTRIBUTORSAUTHER = $scope.data.userName;
            $scope.list.DeptmentalDocId = $state.params.departmentaldocid;
            var list = angular.copy($scope.list);
            // 删除多余字段开始
            delete list.RELEVANTNEWS;
            delete list.RELEVANTOFFICIALS;
            delete list.OBJ_VERSION;
            delete list.LOG_OPERATION;
            delete list.FZ_DOCS;
            // 删除多余字段结束
            // 处理发稿单作者信息空数据提交问题
            if (
                angular.isDefined(list.FGD_AUTHINFO[0]) &&
                (!angular.isDefined(list.FGD_AUTHINFO[0].USERNAME) || list.FGD_AUTHINFO[0].USERNAME === '')
            ) {
                list.FGD_AUTHINFO = [];
            }
            // JSON对象数组转字符串
            list = jsonArrayToStringService.jsonArrayToString(list);
            return list;
        }

        /**
         * [dealAttributeAfterSave description]保存成功后处理属性
         * @param  {[obj]} data [description]保存成功后的返回值
         * @param  {[boolean]} flag [description]标示位
         * @return {[type]}      [description]
         */
        function dealAttributeAfterSave(data, flag) {
            $scope.list.METADATAID = data.METADATAID;
            $scope.list.CHNLDOCID = data.CHNLDOCID;
            $scope.status.isEditDraft = true;
            $stateParams.iwochnldocid = $scope.list.CHNLDOCID;
            $stateParams.iwometadataid = $scope.list.METADATAID;
            $scope.data.incomeData = [
                {
                    TITLE: $scope.list.TITLE,
                    CHNLDOCID: $stateParams.iwochnldocid,
                    METADATAID: $stateParams.iwometadataid,
                },
            ];
            $scope.status.nopayment = true;
            if (flag) {
                if (!$scope.status.isFusionEditor) {
                    storageListenerService.addListenerToIwo('newsSaved');
                    $state.transitionTo($state.current, $stateParams, {
                        reload: false,
                    });
                    $timeout(function () {
                        modalDialog.saveModel('保存成功', '', 'success');
                    }, 500);
                }
            } else {
                $scope.params = {};
            }
        }

        /**
         * [save description]保存函数
         * @param  {[boolean]} flag [description]标示位
         * @return {[type]}      [description]
         */
        function save(flag) {
            var deferred = $q.defer();
            $scope.status.isedit = !!$stateParams.iwometadataid;
            $validation.validate($scope.linkForm.authorForm);
            $scope.linkForm.$pending = {};
            $validation
                .validate($scope.linkForm)
                .success(function () {
                    modalDialog.isSecretInformation(
                        $stateParams.iwometadataid,
                        function () {
                            sensitiveWordCheckService.sensitiveWords($scope).then(
                                function (sensitiveWords) {
                                    $scope.list.ISCONTAINSENSITIVEWORDS = !!sensitiveWords.length ? 1 : 0;
                                    $scope.list.SENSITIVEWORDS = sensitiveWords;
                                    $scope.linkForm.$setPristine();
                                    var list = dealAttributeBeforeSave();
                                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, 'post').then(
                                        function (data) {
                                            $scope.data.METADATAID = data.METADATAID;
                                            if (!$scope.status.isedit) {
                                                $scope.status.isedit = false;
                                            } else {
                                                $scope.status.isedit = true;
                                            }
                                            dealAttributeAfterSave(data, flag);
                                            beforeonload.refresh($scope);
                                            deferred.resolve(data);
                                        },
                                        function (data) {
                                            deferred.reject(data);
                                        }
                                    );
                                },
                                function () {
                                    $scope.status.isCheckSensitiveWords = Math.random();
                                    deferred.reject();
                                }
                            );
                        },
                        function () {
                            deferred.reject();
                        },
                        $scope.status.isFusionEditor
                    );
                })
                .error(function () {
                    editingCenterService.checkSaveError($scope.linkForm, $element, $scope); // 定位输入错的表单位置
                    deferred.reject();
                });
            return deferred.promise;
        }

        /**
         * [addBtn description]新增保存关闭按钮
         */
        function addBtn() {
            $scope.arrayBtn.unshift({
                RIGHTINDEX: 'save',
                OPERDESC: '保存',
                OPERNAME: '保存',
                OPERFUN: 'save',
            });
        }

        /**
         * [getSrcUrl description] 由稿件链接获取稿件页面
         * @return {[type]} [description]
         */
        $scope.getSrcUrl = function () {
            $scope.data.srcUrl = $sce.trustAsResourceUrl($scope.list.URL);
        };
        $scope.updateCKSelection = function (list) {
            list.ISNOPAYMENT === '1' ? (list.ISNOPAYMENT = '0') : (list.ISNOPAYMENT = '1');
        };

        /* 融合编辑器额外功能开始*/
        if ($scope.status.isFusionEditor) {

            /**
             * [pageCantEdit description] 已提交渠道编辑页不能编辑
             * @param  {[type]} type [description] 稿件信息或属性信息
             * @return {[type]}      [description]
             */
            $scope.pageCantEdit = function (type) {
                $timeout(function () {
                    if (type == 'manuscriptInfo') {
                        var manuHeight = $('.body_manuscript').height();
                        var manuWidth = $('.body_manuscript').width();
                        $('.pageCantEdit')
                            .find('.cantEditPart')
                            .height(manuHeight)
                            .width(manuWidth);
                        $('.body_manuscript').resize(function () {
                            $('.pageCantEdit')
                                .find('.cantEditPart')
                                .height($(this).height());
                        });
                    } else if (type == 'attrInfo') {
                        var attrHeight = $('.body_attr_info').height();
                        var attrWidth = $('.body_attr_info').width();
                        $('.pageCantEdit')
                            .find('.cantEditPart')
                            .height(attrHeight)
                            .width(attrWidth);
                        $('.body_attr_info').resize(function () {
                            $('.pageCantEdit')
                                .find('.cantEditPart')
                                .height($(this).height());
                        });
                    }
                }, 300);
            };

            /**
             * [initData description] 融合编辑器切换渠道时的初始化数据
             * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
             * @return {[type]} [description]
             */
            $scope.initData = function (dealWithListFun) {
                var defer = $q.defer();
                if (angular.isDefined($stateParams.iwometadataid)) {
                    initEditData(dealWithListFun).then(function () {
                        loadDirective();
                        defer.resolve();
                    });
                } else {
                    initNewData(dealWithListFun);
                    loadDirective();
                    defer.resolve();
                }
                return defer.promise;
            };

            /**
             * [loadFgd description] 加载发稿单
             * @return {[type]} [description]
             */
            $scope.loadFgd = function () {
                var draftList =
                    '<editor-dir list="list"  meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="linkForm"></editor-dir>' +
                    '<editor-auth-dir author="list.FGD_AUTHINFO" originalchildtype="list.ORIGINAL==1&&data.originType==3?1:0"></editor-auth-dir>';
                draftList = $compile(draftList)($scope);
                $element.find('editor').append(draftList);
            };
            $scope.checkNetHead = function () {
                $scope.returnParams = editingCenterService.checkHasNetHead($scope.list.URL);
                // eslint-disable-next-line no-unneeded-ternary
                $scope.status.showAddHeadTips = $scope.returnParams.hasHead === false ? true : false;
                $scope.list.URL = $scope.returnParams.url;
            };
            $scope.goToPreview = function () {
                window.open($scope.list.URL);
            };
        }

        /* 融合编辑器额外功能结束*/
    },
]);
